import {
  ISolCustomerCurrencyParams,
  ISolCustomerCurrencyResponse,
  ISolCustomerCurrencyService,
} from "@/services/backend/sol_customer/currency/currency.types";
import { BACKEND_BASE_URL, IResponseError } from "@/services";
import { APPLICATION_JSON } from "@/constans";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";

export class SolCustomerCurrencyService implements ISolCustomerCurrencyService {
  async getCurrency(
    params: ISolCustomerCurrencyParams
  ): Promise<ISolCustomerCurrencyResponse | undefined> {
    const headers: Record<string, string> = {
      Accept: APPLICATION_JSON,
    };

    const { response, error } = await handleResponse<
      Promise<ISolCustomerCurrencyResponse | undefined>,
      IResponseError
    >(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/sol-customer/${params.countryCode}/v1/currency`, {
        headers,
        params,
      })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }
}
